import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Button, Notice, Spinner, Text } from 'telia-front-react';
import { useStores } from '../stores/RootStore';
import { FetchStatus } from '../util/FetchStatus';

const CancelReservation = observer((): React.JSX.Element => {
  const {
    reservationStore: { isReservationFetching, reservation, reservationStatus, reservationCancelStatus, errorType, fetchReservation, cancelReservation }
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  React.useEffect(() => {
    fetchReservation();
  }, []);

  const renderErrorNotice = (): React.JSX.Element => {
    if ([reservationStatus, reservationCancelStatus].includes(FetchStatus.ERROR)) {
      return (
        <Notice attributes={{ 'aria-live': 'polite' }} type="error">
          {translate(`reservation.cancel.error${reservationStatus === FetchStatus.ERROR ? `.${errorType}` : ''}`)}
        </Notice>
      );
    }
  };

  const renderContent = () => {
    if (reservationCancelStatus === FetchStatus.FETCHED) {
      return (
        <Notice attributes={{ 'aria-live': 'polite' }} type="success">
          {translate('reservation.cancel.success')}
        </Notice>
      );
    }
    return (
      <Text>
        {renderErrorNotice()}
        <AnalyticsTrigger trigger={{ id: 'Button - Cancel reservation', callback: 'onClick' }}>
          <Button
            text={translate('reservation.cancel.button')}
            variant="secondary"
            onClick={cancelReservation}
            disabled={reservation?.stateCode !== 'RESERVED' || reservationStatus === FetchStatus.ERROR}
            isLoading={reservationCancelStatus === FetchStatus.FETCHING}
          />
        </AnalyticsTrigger>
      </Text>
    );
  };

  return isReservationFetching ? <Spinner /> : renderContent();
});

export default CancelReservation;
